export enum DIRECTIONS {
  top,
  bottom,
  left,
  right
}
